"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Wapp = require("wapplr-react/dist/common/Wapp");
var _withMaterial = require("common-components/dist/common/components/Template/withMaterial");
var _Logo = _interopRequireDefault(require("../../components/Logo"));
var _materialStyle = _interopRequireDefault(require("./materialStyle"));
//import getUtils from "wapplr-react/dist/common/Wapp/getUtils";
//import AppContext from "common-components/dist/common/components/App/context";
var style = require("./style_css.js")["default"];
function BlankScreen( /*props*/
) {
  var context = (0, _react.useContext)(_Wapp.WappContext);
  //const appContext = useContext(AppContext);
  var wapp = context.wapp;
  //const utils = getUtils(context);
  //const {menus, routes} = appContext;
  //const {/*subscribe, materialStyle*/} = props;

  wapp.styles.use(style);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: style.blankScreen
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.centerContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.logoContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.logo
  }, /*#__PURE__*/_react["default"].createElement(_Logo["default"], {
    type: "icon"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.logoText
  }, /*#__PURE__*/_react["default"].createElement(_Logo["default"], null)))));
}
var WappComponent = (0, _Wapp.withWapp)(BlankScreen);
var StyledComponent = (0, _withMaterial.withMaterialStyles)(_materialStyle["default"], WappComponent);
var _default = StyledComponent;
exports["default"] = _default;